// extracted by mini-css-extract-plugin
module.exports = {"container":"BlocksView_container__OCJ93"};